/**
 * Run non-critical work (analytics, translate widget, third-party
 * scripts) after the page has finished its critical rendering work.
 *
 * Anything scheduled here is guaranteed not to compete with the hero
 * image/video fetch or the first paint, which is what drives LCP.
 * The callback still always runs — worst case on a timeout — so
 * behavior is unchanged, only its timing moves.
 */
export function whenIdle(callback, timeout = 3000) {
  if (typeof window === "undefined") return;

  const run = () => {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(callback, { timeout });
    } else {
      window.setTimeout(callback, 200);
    }
  };

  if (document.readyState === "complete") {
    run();
  } else {
    window.addEventListener("load", run, { once: true });
  }
}

export default whenIdle;
